"use strict";
var Observable_1 = require('../../Observable');
var bindCallback_1 = require('../../observable/bindCallback');
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/rxjs/add/observable/bindCallback.js
// module id = amjc
// module chunks = 6